import React from 'react';
import { useLocation } from 'react-router-dom';
import { TopBar } from '../components/layout/TopBar';
import { Header } from '../components/layout/Header';
import { Navigation } from '../components/layout/Navigation';
import { MobileStickyBar } from '../components/layout/MobileStickyBar';
import { Footer } from '../components/layout/Footer';
import { ArrowLeft, ExternalLink } from 'lucide-react';
import { usePageTitle } from '../hooks/usePageTitle';
export function LegacyPreview() {
  const location = useLocation();
  usePageTitle('Legacy Website Forge URL | MidAtlantic Mailboxes');
  return <div className="min-h-screen flex flex-col bg-brand-cream" data-id="element-2117" data-mp="2wt82upd5r53p">
      <TopBar data-id="element-2118" data-mp="2wut04mqux259" />
      <Header data-id="element-2119" data-mp="31rt5evfvu0vb" />
      <Navigation data-id="element-2120" data-mp="31r9kd5uxqwd2" />

      <main className="flex-grow flex items-center justify-center px-4 py-20" data-id="element-2121" data-mp="31sug2yszklci">
        <div className="max-w-xl w-full bg-white rounded-2xl border border-brand-border shadow-sm p-8 lg:p-12 text-center" data-id="element-2122" data-mp="v0tou1dqiksk">
          <div className="w-14 h-14 rounded-full bg-brand-green/10 text-brand-green flex items-center justify-center mx-auto mb-6" data-id="element-2123" data-mp="zz4x47odsn8o">
            <ExternalLink size={26} data-id="element-2124" data-mp="1fmg9k1wkkdtv" />
          </div>
          <h1 className="text-2xl lg:text-3xl font-serif font-bold text-brand-charcoal mb-3" data-id="element-2125" data-mp="1aq7yazlht4rz">
            Legacy Website Forge URL
          </h1>
          <p className="text-gray-600 leading-relaxed mb-2" data-id="element-2126" data-mp="1pgf86qxfpfh2">
            This preview preserves the legacy Website Forge URL for this
            section.
          </p>
          <p className="text-sm text-gray-500 font-mono bg-brand-cream border border-brand-border rounded-md px-3 py-2 inline-block mb-8 break-all" data-id="element-2127" data-mp="wqghys7i7cat">
            {location.pathname}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-2128" data-mp="15r4v7kp2p8mn">
            <a href="/Home.html" className="inline-flex items-center justify-center gap-2 bg-brand-green hover:bg-brand-green/90 text-white px-6 py-3 rounded-md font-semibold transition-colors" data-id="element-2129" data-mp="11o8g43yqrung">
              <ArrowLeft size={18} data-id="element-2130" data-mp="2d3dl5emci5a8" /> Back to Home
            </a>
            <a href="/ContactUs.html" className="inline-flex items-center justify-center bg-white border border-brand-border hover:border-brand-green text-brand-charcoal px-6 py-3 rounded-md font-semibold transition-colors" data-id="element-2131" data-mp="19tst3hmdgp39">
              Contact / Get help
            </a>
          </div>
        </div>
      </main>

      <Footer data-id="element-2132" data-mp="1nqobw1sfduwi" />
      <MobileStickyBar data-id="element-2133" data-mp="r2i6hcnoiyh6" />
    </div>;
}